import { Button } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  height: auto;

  p {
    cursor: pointer;
    :hover {
      color: ${(props) => props.theme.primary.light};
      transition: 0.4s;
    }

    svg {
      margin-right: 10px;
      vertical-align: middle;
    }
  }
`;

export const DaysContainer = styled.div`
  margin: 25px 0px;
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

export const DateButton = styled.button`
  width: 100px;
  border: 0;
  color: #444;
  border-radius: 4px;
  height: 30px;
`;

export const FilterContent = styled.div`
  display: flex;
  margin-top: 20px;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  color: #444;

  form {
    flex-wrap: wrap;
    gap: 10px;
    display: flex;
  }
`;

export const ReportButton = styled(Button)`
  && {
    font-size: 0.925rem;
    
    background: ${e => e.theme.primary.original} !important;
    border-color: ${e => e.theme.primary.original} !important;
    color: #fff !important;
    box-shadow: none !important;
    height: 36px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    padding: 0 12px;
    white-space: nowrap;
    text-transform: none;

    &:hover,
    &:focus {
      background-color: ${e => e.theme.primary.original};
      filter: brightness(0.9);
      color: #fff !important;
      box-shadow: none !important;
    }

    svg {
      color: #fff;
    }
  }
`;
